import styled from 'styled-components'

// import { mq, sizes } from '../../theme'
import Icon from '../Icon'

import { COVER_SEARCH_VARIANT } from './types'

export const CoverSearch = styled.section`
  position: relative;
  z-index: 2;
`

export const Form = styled.form`
  background: ${({ theme }) => theme.colors.pureWhite};
  display: flex;
  align-items: center;
  padding: 0 2rem;
  min-height: 4rem;
  border-radius: 2.5rem;
`

export const Button = styled.button`
  width: 2.2rem;
  background: white;
  appearance: none;
  border: none;
`
export const Svg = styled(Icon)`
  width: 2.2rem;
  height: 2.2rem;
  display: block;
`

export const CoverSearchContent = styled.div``
export const Input = styled.input<{ $variant?: COVER_SEARCH_VARIANT }>`
  ${Button} +  & {
    padding-left: 2.5rem;
  }
  ${({ theme }) => theme.textStyles.text_bold_condensed_15};
  color: ${({ theme }) => theme.colors.pureBlack};
  background: ${({ theme }) => theme.colors.pureWhite};
  border: none;
  appearance: none;
  min-width: ${({ $variant }) =>
    $variant === COVER_SEARCH_VARIANT.EVENT ? '26rem' : '22rem'};
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${({ theme }) => theme.colors.pureBlack};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${({ theme }) => theme.colors.pureBlack};
  }
`
